import React, { useState, useEffect } from "react";
import "./enquirypreferencepopup.scss";
import "../AboutPopUp/aboutPopUp.scss";
import Modal from "react-bootstrap/Modal";
import { blackDeleteicon, modalClose } from "../../../../../images";
import style from "../../../../../../src/pages/FormFiveLightTheme/Form/formfivelighttheme.module.scss";
import CheckboxButton from "../../../../../components/CheckboxButton/CheckboxButton";
import AutoCompleteOthers from "../../../../../components/AutoCompleteOthers/AutoCompleteOthers";
import Joi from "joi";
import { TextField } from "@mui/material";
import FullWidthTextField from "../../../../../components/TextField/FullWidthTextField";
import CountryCodeDropdown from "../../../../../components/CountryCodeDropdown/CountryCodeDropdown";
import CustomCheckBoxInput from "../../../../../components/CustomCheckBoxInput/CustomCheckBoxInput";
import AutoCompleteField from "../../../../../components/AutoCompleteField/AutoCompleteField";
// import style from "../../../../FormFiveLightTheme/Form/formfivelighttheme.module.scss";

const EnquiryPrefrencePopup = ({
  show,
  onHide,
  onSaveBusinessHours,
  businessHours,
}) => {
  const handleCancel = () => {
    // resetToOriginalValues();
    onHide();
  };

  const contactMethodOptions = [
    { label: "Email Id", value: "Email Id" },
    { label: "WhatsApp", value: "WhatsApp" },
    { label: "Phone Call", value: "Phone Call" },
  ];

  const countries = [
    {
      label: "Owner/s",
      value: "Owner/s",
    },
    {
      label: "Business Contact Person",
      value: "Business Contact Person",
    },
    {
      label: "Both",
      value: "Both",
    },
  ];

  return (
    <Modal
      show={show}
      centered
      className="Complete_actions_popup EnquiryPrefrencePopup"
      backdropClassName="custom-backdrop"
    >
      <Modal.Header>
        <button
          className="Complete_actions_popup_cancel_btn"
          onClick={handleCancel}
        >
          <img
            src={modalClose}
            alt="close-icon"
            className="Complete_actions_popup_cancel_btn_img"
          />
        </button>
      </Modal.Header>
      <Modal.Body>
        <h2 className="Complete_actions_popup_m_heading">Enquiry Prefrence </h2>

        <div className={`row ${style.spacing_rl_row_recive_queries}`}>
          <div
            className={`col-lg-6  ${style.rstep01_col}
            ${style.col_padding_recive_queries01}`}
          >
            <div
              className={`${style.field_wrapper} ${style.form_recive_queries_single_wrapper}`}
            >
              <div className={style.heading_recive_queries}>
                Projects/Business
              </div>
              <AutoCompleteField
                lightTheme
                key="projects_contact_person"
                textLabel="Person to contact"
                data={countries}
                // value={
                //   countries.find(
                //     (option) =>
                //       option.value ===
                //       formData.enquiry_preferences.projects_business
                //         .contact_person
                //   ) || { value: "Both" }
                // }
                // onChange={(e, option) =>
                //   handleSelectChange(
                //     option.value || "Both",
                //     "projects_business"
                //   )
                // }
                disablePortal
              />
              {/* <div id="projects_business_contact_person_error">
                {formError.projects_business_contact_person && (
                  <p className={style.error}>
                    {formError.projects_business_contact_person}
                  </p>
                )}
              </div> */}

              {/* <p className={style.error}>
                        Error messsage here error messsage
                      </p> */}
              <div className={style.custom_check_box_warper_recive_queries}>
                {contactMethodOptions.map((method, index) => (
                  <CustomCheckBoxInput
                    key={index}
                    label={method.label}
                    // checked={formData?.enquiry_preferences?.projects_business?.contact_methods?.includes?.(
                    //   method.value
                    // )}
                    // onChange={(e) =>
                    //   handleCheckboxChange(
                    //     "projects_business",
                    //     method.value,
                    //     e.target.checked
                    //   )
                    // }
                  />
                ))}
              </div>
              {/* <div id="projects_business_contact_methods_error">
                {formError.projects_business_contact_methods && (
                  <p className={style.error}>
                    {formError.projects_business_contact_methods}
                  </p>
                )}
              </div> */}
            </div>
          </div>

          <div
            className={`col-lg-6  ${style.rstep01_col} ${style.col_padding_recive_queries02}`}
          >
            <div className={style.field_wrapper}>
              <div className={style.heading_recive_queries}>
                Product/Material Showcase
              </div>
              <AutoCompleteField
                lightTheme
                key="product_material_contact_person"
                textLabel="Person to contact"
                data={countries}
                disablePortal
              />
              {/* <div id="product_material_contact_person_error">
                {formError.product_material_contact_person && (
                  <p className={style.error}>
                    {formError.product_material_contact_person}
                  </p>
                )}
              </div> */}

              {/* <p className={style.error}>
                        Error messsage here error messsage
                      </p> */}
              <div className={style.custom_check_box_warper_recive_queries}>
                {contactMethodOptions.map((method, index) => (
                  <CustomCheckBoxInput key={index} label={method.label} />
                ))}
              </div>
              {/* <div id="product_material_contact_methods_error">
                {formError.product_material_contact_methods && (
                  <p className={style.error}>
                    {formError.product_material_contact_methods}
                  </p>
                )}
              </div> */}
            </div>
          </div>

          <div
            className={`col-lg-6  ${style.rstep01_col} ${style.col_padding_recive_queries03}`}
          >
            <div className={style.field_wrapper}>
              <div className={style.heading_recive_queries}>
                Jobs/Internship/Hiring
              </div>
              <AutoCompleteField
                lightTheme
                key="jobs_internships_contact_person"
                textLabel="Person to contact"
                data={countries}
                disablePortal
              />
              {/* <div id="jobs_internships_contact_person_error">
                {formError.jobs_internships_contact_person && (
                  <p className={style.error}>
                    {formError.jobs_internships_contact_person}
                  </p>
                )}
              </div> */}

              <div className={style.custom_check_box_warper_recive_queries}>
                {contactMethodOptions.map((method, index) => (
                  <CustomCheckBoxInput key={index} label={method.label} />
                ))}
              </div>
              {/* <div id="jobs_internships_contact_methods_error">
                {formError.jobs_internships_contact_methods && (
                  <p className={style.error}>
                    {formError.jobs_internships_contact_methods}
                  </p>
                )}
              </div> */}
            </div>
          </div>

          <div
            className={`col-lg-6  ${style.rstep01_col} ${style.col_padding_recive_queries04}`}
          >
            <div className={style.field_wrapper}>
              <div className={style.heading_recive_queries}>
                Media/PR/Events
              </div>
              <AutoCompleteField
                lightTheme
                key="media_pr_contact_person"
                textLabel="Person to contact"
                data={countries}
                disablePortal
              />
              {/* <div id="media_pr_contact_person_error">
                {formError.media_pr_contact_person && (
                  <p className={style.error}>
                    {formError.media_pr_contact_person}
                  </p>
                )}
              </div> */}

              <div className={style.custom_check_box_warper_recive_queries}>
                {contactMethodOptions.map((method, index) => (
                  <CustomCheckBoxInput key={index} label={method.label} />
                ))}
              </div>
              {/* <div id="media_pr_contact_methods_error">
                {formError.media_pr_contact_methods && (
                  <p className={style.error}>
                    {formError.media_pr_contact_methods}
                  </p>
                )}
              </div> */}
            </div>
          </div>
        </div>

        <button
          type="button"
          className="confirmation_common_btn"
          // onClick={handleSaveChanges}
        >
          Save Changes
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default EnquiryPrefrencePopup;
